import { render, staticRenderFns } from "./EditMessage.vue?vue&type=template&id=714fa259&scoped=true&"
import script from "./EditMessage.vue?vue&type=script&lang=js&"
export * from "./EditMessage.vue?vue&type=script&lang=js&"
import style0 from "./EditMessage.vue?vue&type=style&index=0&id=714fa259&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714fa259",
  null
  
)

export default component.exports